import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   language: hasConsent("functional")
//     ? localStorage.getItem("i18nextLng")
//     : null,
// };
const getLanguageFromUrl = () => {
  const pathname = window.location.pathname;
  const match = pathname.match(/^\/(en|vi)(\/|$)/);
  return match ? match[1] : "en";
};
// const initialState = {
//   language: localStorage.getItem("i18nextLng") || "en",  
// };
const initialState = {
  language: getLanguageFromUrl(),
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    changeLanguage: (state, action) => {
      state.language = action.payload;

      // if (hasConsent("functional")) {
      //   localStorage.setItem("i18nextLng", action.payload);
      // } else {
      //   localStorage.removeItem("i18nextLng");
      // }
    },
  },
  extraReducers: (builder) => {},
});
export const { changeLanguage } = languageSlice.actions;

export default languageSlice.reducer;
